// extracted by mini-css-extract-plugin
export default {"container":"styles__container___hAlwP","text":"styles__text___iXAmu","separator":"styles__separator___1eV1i"};